import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ZapierForm from 'react-zapier-form'
import Checkbox from './Inputs/checkbox'
import Textarea from './Inputs/textarea'
import TextInput from './Inputs/text'
import SVG from 'react-inlinesvg'
import MGSymbol from '../../assets/svg/shape-copy.svg'

/* all forms except support */
const StyledForm = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  width: 100%;

  svg {
    margin: 16px auto;
  }

  ${({ theme }) => theme.media.desktop} {
    max-width: 820px;
  }
`

const StyledFormWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  padding: 16px 0;
  width: 100%;
  margin: auto auto;

  ${({ theme }) => theme.media.tablet} {
    padding: 16px 16px;
  }
  
  ${({ theme }) => theme.media.desktop} {
    max-width: 820px;
  }
`

const StyledHeading = styled.div`
  display: ${({ rightColumnForm }) => (rightColumnForm ? 'block' : 'none')};
  margin: 16px 0;

  svg {
    margin: 0 auto 16px;
    width: 100%;
  }

  h4 {
    font-size: 20px;
    text-align: center;
  }
`

const StyledColumn = styled.div`
  .submit {
    display: block;
    background-color: #c02428;
    border-radius: 400px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.71;
    margin: 16px auto 0;
    padding: 12px 24px;
    transition: 250ms;
  }

  ${({ theme }) => theme.media.tablet} {
    display: flex;
    flex-basis: 100%;
    flex-direction: row;
    flex: 1;
    width: 100%;
  }

  :first-child {
    margin-top: 16px;
  }
  
  :last-child {
    padding-bottom: 0;
  }
`

const PricingPageForm = ({ onChange }) => {
  useEffect(() => {
    window.addEventListener('submit', (event) => {
      event.preventDefault();
      window.location.href = 'https://www.mailgun.com/enterprise/thanks';
    });  
  },)

  function handleChange(e) {
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <StyledForm>
        <ZapierForm action="https://hooks.zapier.com/hooks/catch/265526/osv0o3s/">
          {({ loading, success }) => {
            return (
              <StyledFormWrapper>
                {!success && !loading &&
                  <div>
                    <StyledHeading>
                      <SVG src={MGSymbol} />
                      <h4>hi</h4>
                    </StyledHeading>
                    <StyledColumn>
                      <TextInput
                        id="first-name"
                        name='first-name'
                        onChange={e => handleChange(e)}
                        placeholder='First Name*' 
                        required={true}
                        type='text'
                      />
                      <TextInput 
                        id="last-name"
                        name='last-name'
                        onChange={e => handleChange(e)}
                        placeholder='Last Name*' 
                        required={true}
                        type='text'
                      />
                    </StyledColumn>
                    <StyledColumn>
                      <TextInput
                        id="company"
                        name='company'
                        onChange={e => handleChange(e)}
                        placeholder='Company*' 
                        required={true}
                        type='text'
                      />
                      <TextInput
                        id="work-email"
                        name='work-email'
                        onChange={e => handleChange(e)}
                        placeholder='Email*' 
                        required={true}
                        type='email'
                      />
                    </StyledColumn>
                    <StyledColumn>
                      <TextInput
                        id="expected-monthly-email"
                        name='expected-monthly-email'
                        onChange={e => handleChange(e)}
                        placeholder='Expected Monthly Emails*' 
                        required={true}
                        type='number'
                      />
                    </StyledColumn>
                    <Textarea
                      onChange={e => handleChange(e)}
                      id="textarea" 
                      name='message' 
                      placeholder='Anything you would like to add about your use case?'
                      textarea={true} 
                    />
                    <Checkbox
                      checkbox={true}
                      id="checkbox"
                      name='subscribe-checkbox'
                      onChange={e => handleChange(e)}
                      placeholder='Your message' 
                      text="I'd love to get the latest Mailgun blog in my inbox every week"
                    />
                    <StyledColumn>
                      <button
                        className="submit"
                        id="submitButton"
                        onChange={e => handleChange(e)}
                        type="submit" 
                        value="Submit"
                      >
                        Contact Us
                      </button>
                    </StyledColumn>
                    <StyledColumn>
                      <TextInput
                        hidden={true}
                        id="hidden-input"
                        name="submitted-form"
                        onChange={e => handleChange(e)}
                        value={'hi'}
                      />
                    </StyledColumn>
                  </div>
                }
              </StyledFormWrapper>
            )
          }}
        </ZapierForm>
    </StyledForm>
  )
}

PricingPageForm.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

export default PricingPageForm